import CONST_REQUEST from '../../constants/request';
import * as api from '../../webpublicapi/customer';
import apiTools from '../../utils/store'


const types = {
    ...apiTools.getTypes([
        'customerList',
        'customerQryList',
        'customerDetail',
        'checkBankCard',
      'testCustomerList',
      'addWritelist',
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'customerList',
            'customerQryList',
          'testCustomerList',
            'customerDetail',
          'checkBankCard',
          'addWritelist',
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'customerList',
            'customerQryList',
            'customerDetail',
          'testCustomerList',
          'checkBankCard',
          'addWritelist',
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getCustomerList',
          'getTestCustomerList',
            'getCustomerQryList',
            'getCustomerDetail',
            'checkBankCard',
            'addWritelist',



        ], { types, api, CONST_REQUEST }),
    }

const mutations = {
    ...apiTools.getMutations([
        'customerList',
      'testCustomerList',
        'customerQryList',
        'customerDetail',
      'checkBankCard',
      'addWritelist',
    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}